import Bank from '@/api/bank'

export default {
  fetchBank: ({ commit }) => {
    commit('changeLoading', { isLoading: true })
    return Bank.fetch()
      .then(({ data }) => {
        commit('changeLoading', { isLoading: false })
        commit('updateBank', { bank: data })
      })
      .catch(error => {
        commit('changeLoading', { isLoading: false })
        throw error
      })
  },
  fetchKyc: ({ commit }) => {
    commit('changeLoading', { isLoading: true })
    return Bank.fetchKyc()
      .then(({ data }) => {
        commit('updateKyc', { kyc: data })
        commit('changeLoading', { isLoading: false })
      })
      .catch(error => {
        commit('changeLoading', { isLoading: false })
        throw error
      })
  },
  save: ({ commit }, { data }) => {
    commit('changeLoading', { isLoading: true })
    return Bank.save({ data })
      .then(({ data }) => {
        commit('updateBank', { bank: data })
        commit('changeLoading', { isLoading: false })
      })
      .catch(err => {
        commit('changeLoading', { isLoading: false })
        err.response.data = { iban: ['is invalid'] }
        throw err
      })
  }
}



// WEBPACK FOOTER //
// ./src/store/skiliko/bank/actions.js